import GenericRequest, { METHOD_GET } from '../../../shared/webservices/GenericRequest';

export class DashboardTask extends GenericRequest {

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/dashboard/widgets/dashboard/DashboardTask.js